
import { Component, Vue } from 'vue-property-decorator';

interface Link {
  name: string;
  link: string;
}

@Component
export default class CPFooter extends Vue {
  public quickLinks1: Link[] = [
    { name: 'Currency Converter', link: '/utilities/currency-converter' },
    { name: 'Risk Profile', link: '/utilities/risk-profile' },
    { name: 'Glossary', link: '/utilities/glossary' },

  ];
  public quickLinks2: Link[] = [
    { name: 'Investing FAQs', link: '/faqs/investing' },
    { name: 'Terminology', link: '/faqs/terminology' },
    { name: 'My Alerts Overview', link: '/faqs/alerts' },
  ];
  public quickLinks3: Link[] = [
    { name: 'How to - Cash Transfer', link: '/how-to/send-cash' },
    { name: 'How to - Remit Cash Out', link: '/how-to/remit-cash' },
    { name: 'How to - Buy & Sell Funds', link: '/how-to/buy-sell' },
  ];

  public get addressDetails() {
    return this.$store.state.utils.addressDetails;
  }


  public get addressTitle() {
      return this.addressDetails.split('\n')[0].replace(/(<([^>]+)>)/ig, '');
  }

  public addressOpen: boolean = false;

  public toggleAddress() {
    this.addressOpen = !this.addressOpen;
  }


  public mounted() {
    this.$store.dispatch('getAddressDetails');
  }
}
